<div class="container-fluid">
  <div class="row dragndrop-toolbar-wide">
    <div class="col-md-4 col-sm-12">
      <div>
        <img class="process-task-logo-image" [src]="taskModel.task.plugin?.logoBlobUrl" />
      </div>
    </div>
    <div class="col-md-4 col-sm-12 d-flex justify-content-center">
      <div class="process-task-computing-units-counter" matTooltip="The computing units that this task will require" *ngIf="!!user && taskModel.task.taskBlocks.length > 0">Computing Units Used: {{taskModel.task.computingUnits}}/{{user.computingUnits + user.computingUnitsExtra}} </div>
    </div>
    <div class="col-md-4 col-sm-12 d-flex align-items-center justify-content-end">
      <div class="task-buttons">
        <button mat-raised-button color="accent" (click)="startProcessing()" [disabled]="taskModel.task.taskBlocks.length < 1"> <fa-icon [icon]="faCirclePlay"></fa-icon> Process</button>
        <button mat-raised-button color="primary" (click)="clearTask()">
          <fa-icon [icon]="faTrashCan"></fa-icon> Cancel
        </button>
      </div>
    </div>
  </div>
  <div class="row dragndrop-toolbar-small justify-content-center">
    <img class="process-task-logo-image" [src]="taskModel.task.plugin?.logoBlobUrl" />
    <div class="process-task-computing-units-counter d-flex justify-content-center" matTooltip="The computing units that this task will require" *ngIf="!!user && taskModel.task.taskBlocks.length > 0">
      Computing Units Used: {{taskModel.task.computingUnits}}/{{user.computingUnits + user.computingUnitsExtra}}
    </div>
    <div class="col-md-4 col-sm-12 d-flex align-items-center justify-content-center">
      <div class="task-buttons d-flex justify-content-center">
        <button mat-raised-button color="accent" (click)="startProcessing()" [disabled]="taskModel.task.taskBlocks.length < 1"> <fa-icon [icon]="faCirclePlay"></fa-icon> Process</button>
        <button mat-raised-button color="primary" (click)="clearTask()">
          <fa-icon [icon]="faTrashCan"></fa-icon> Cancel
        </button>
      </div>
    </div>
  </div>
  <div class="row d-flex justify-content-center">
    <div class="dragndrop-container" appDnd (fileDropped)="onBlockDropped($event)">
      <input type="file" (click)="itemDropRef.value = ''" #itemDropRef id="itemDropRef" multiple (change)="onBlockAdded($event)" accept="{{extensions}}" />
      <h3>Drag and drop your files here ({{extensions}})</h3>
      <h3>or</h3>
      <button mat-raised-button color="accent"><fa-icon [icon]="faArrowPointer"></fa-icon> Select files</button>
    </div>
  </div>
  <div class="items-list">
    <div class="single-item" *ngFor="let block of taskModel.task.taskBlocks; let i = index">
      <app-task-creator-tile class="w-100" [block]="block" [plugin]="taskModel.task.plugin"
                             (loadBlockEvent)="loadBlock($event, data)"
                             (stopAllPlayersEvent)="stopAllPlayers($event)"
                             (deleteBlockEvent)="deleteBlock($event, block)"
                             (previewBlockEvent)="previewBlock($event)"
                             (openInfoBlockEvent)="openInfoBlock($event)"></app-task-creator-tile>
    </div>
  </div>
</div>



